import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_ADMIN_LOCAL_API_REQUESTS } from './constants';

export const setAdminSensorOrderReady = async (orderId) => {
  const request = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/set-ready`,
    body: {},
    isLocalApiRequest: RENOLOG_ADMIN_LOCAL_API_REQUESTS,
  });
  const response = await axios(request);
  return response.data;
};
